module.exports = __webpack_public_path__ + "static/img/burgerking.37028609.png";